import { EntityQuery, FilterQueryOp } from 'breeze-client';
import { BaseEntity } from '../../base-entity';
import { PbiDataset, ReportCategory } from '../../models';

const baseQuery = EntityQuery.from('PbiDatasets');
const selectAll = baseQuery.expand(PbiDataset.propName('dataset'));
const selectAskAgoraDatasets = baseQuery
  .where(BaseEntity.getPropPath(['dataset', 'category']), FilterQueryOp.StartsWith, ReportCategory.AskAgora)
  .select([
    PbiDataset.propName('name'),
    BaseEntity.getPropPath(['dataset', 'organisationWorkspace', 'templateWorkspace', 'name']),
    BaseEntity.getPropPath(['dataset', 'category'])
  ])
  .orderBy(BaseEntity.getPropPath(['dataset', 'category']));

export const pbiDatasetQueries = {
  selectAll,
  selectAskAgoraDatasets
};
